import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function PaymentSuccess(_props: any) {
  const { t } = useTranslation();
  return (
    <Navigate
      to="/accountpayment"
      state={{ infoForUser: t("PAYMENT_PAGE.PAYMENT_SUCCESS") }}
      replace
    />
  );
}
